import React from 'react';

// TODO we should eventually treat these as image assets and move them out of the application
export const ChatSVG = () => (
	<svg
		width="200"
		height="200"
		viewBox="0 0 480 480"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M308.752 279.491C293.539 213.065 217.146 174.165 138.148 192.585C59.1499 211.005 7.44173 279.79 22.6553 346.186C28.5284 371.818 60.6671 402.782 60.6671 402.782C60.6671 423.482 28.5461 453.698 23.3587 458.442C23.0738 458.703 23.2091 459.151 23.5928 459.195C31.3632 460.086 85.6496 465.002 119.272 433.092C138.925 435.809 172.127 438.018 193.26 433.092C272.258 414.672 323.966 345.917 308.752 279.491Z"
			fill="#C4DFF9"
		/>
		<path
			d="M126.454 150.738C124.959 79.9912 192.044 21.4762 276.263 20.0274C360.483 18.5786 429.97 74.7589 431.458 145.476C432.032 172.776 407.505 212.095 407.505 212.095C412.775 233.057 453.185 255.484 459.271 258.759C459.584 258.927 459.555 259.357 459.223 259.483C452.006 262.216 398.287 281.186 356.159 257.456C337.055 265.167 304.178 275.797 281.649 276.187C197.429 277.635 127.95 221.485 126.454 150.738Z"
			fill="#FFE4FB"
		/>
		<path
			d="M323.783 75.9948L324.031 108.448H238.398L238.152 76.5533C238.146 72.0098 242.76 70.1867 246.683 69.5004C248.529 69.271 250.606 69.0413 252.683 68.8116C264.222 67.4345 289.793 65.3576 314.726 69.4164C318.651 70.0932 323.778 71.6784 323.783 75.9948Z"
			fill="#FBBB03"
		/>
		<path
			d="M231.368 125.762C231.643 139.951 231.666 158.571 231.666 158.571C231.666 158.571 229.589 158.8 228.898 159.483C227.976 160.392 227.054 161.529 227.286 162.892C227.504 166.867 235.742 166.786 239.928 166.745C240.288 166.741 240.617 166.738 240.909 166.738C247.372 166.73 253.835 166.722 260.297 166.487C260.88 166.486 261.467 166.474 262.05 166.461C266.546 166.363 270.869 166.27 272.306 171.697C272.538 172.379 272.775 177.603 272.778 179.648C272.778 179.648 272.406 188.591 272.329 189.871L272.311 190.168C271.87 197.494 271.589 202.168 267.419 208.786C262.728 216.231 253.705 221.964 248.746 225.114C248.364 225.357 248.007 225.584 247.677 225.795C245.37 227.161 242.605 230.345 249.53 231.245L250.223 231.245C259.457 232.596 270.306 233.265 281.847 233.478C292.465 233.692 302.389 233.226 310.928 232.307C313.467 232.076 315.775 231.619 318.082 230.935C319.927 230.251 321.31 228.432 320.846 226.388C320.382 224.344 318.303 223.438 316.456 222.758C312.444 221.283 304.358 215.814 301.209 212.41C298.06 209.006 295.427 202.565 294.266 197.796C293.571 195.298 292.858 179.396 292.858 179.396C292.624 176.898 293.771 171.217 294.233 170.762C295.614 168.261 298.151 166.668 300.921 166.665L333.466 166.398C335.543 166.395 337.157 165.03 337.385 162.985C337.842 159.35 334.609 157.991 331.609 158.222C331.781 147.441 331.654 136.661 331.469 125.762H231.368Z"
			fill="#FA592D"
		/>
		<path
			d="M233.615 103.703C265.358 98.5126 297.96 98.5372 329.707 103.703C332.879 103.703 332.178 106.473 332.178 109.881L331.836 158.265L231.109 158.683V109.881C231.109 106.473 230.443 103.703 233.615 103.703Z"
			fill="#FB8B00"
		/>
		<path
			d="M263.609 107.32C267.41 102.794 267.048 96.6994 262.885 93.6218C259.023 90.7857 253.23 91.5701 249.368 95.3115C249.006 94.527 248.583 93.8029 248.04 93.1391C244.962 89.3374 237.842 85.9888 234.463 88.7646C232.049 90.7559 233.075 96.5184 233.98 99.6562C233.497 99.7769 233.014 99.958 232.532 100.199C227.101 102.553 224.687 108.165 227.04 112.811C228.489 115.587 231.264 117.337 234.463 117.82C234.402 118.001 234.342 118.182 234.282 118.423C232.894 123.13 234.34 130.196 238.564 131.403C242.788 132.61 248.161 127.535 249.549 122.828C249.549 122.708 249.609 122.647 249.609 122.527C253.169 125.604 260.23 127.52 263.609 124.623C267.41 121.304 265.6 113.415 262.342 108.768C262.764 108.285 263.186 107.803 263.609 107.32ZM251.359 109.432C250.454 112.027 247.557 113.958 244.842 113.656C242.126 113.415 240.678 111.061 241.583 108.466C242.488 105.872 245.385 103.941 248.1 104.242C250.816 104.484 252.264 106.837 251.359 109.432Z"
			fill="#FA38C4"
		/>
		<path
			d="M307.709 87.7267C313.519 88.8109 318.648 85.4981 319.28 80.3591C319.85 75.6016 316.318 70.9435 311.161 69.4209C311.666 68.7199 312.088 67.9959 312.399 67.1966C314.196 62.6472 313.609 54.8004 309.53 53.2233C306.609 52.1011 302.096 55.8284 299.81 58.1598C299.467 57.7989 299.072 57.4675 298.624 57.1659C293.904 53.5947 287.831 54.2532 284.942 58.5876C283.238 61.2138 283.079 64.4913 284.232 67.5135C284.045 67.5499 283.857 67.5865 283.618 67.6527C278.837 68.7592 273.396 73.4938 274.422 77.7653C275.449 82.0367 282.51 84.2186 287.291 83.1121C287.396 83.0527 287.478 83.0756 287.583 83.0162C286.655 87.6298 288.459 94.7192 292.643 96.2369C297.403 97.9147 303.382 92.4582 305.825 87.3357C306.453 87.466 307.081 87.5964 307.709 87.7267ZM299.845 78.0996C297.141 78.5877 294.035 77.0155 292.962 74.5027C291.837 72.0197 293.174 69.6012 295.878 69.1131C298.582 68.625 301.688 70.1973 302.761 72.71C303.887 75.1931 302.55 77.6115 299.845 78.0996Z"
			fill="#FA38C4"
		/>
		<path
			d="M128.857 304.005C121.971 299.467 113.099 300.738 109.031 306.884C104.937 312.999 107.25 321.631 114.13 326.168C121.016 330.706 129.888 329.435 133.956 323.289C137.994 317.169 135.717 308.512 128.857 304.005Z"
			fill="#559BF0"
		/>
		<path
			d="M173.577 304.005C166.691 299.467 157.82 300.738 153.752 306.884C149.658 312.999 151.97 321.631 158.851 326.168C165.737 330.706 174.608 329.435 178.677 323.289C182.714 317.169 180.438 308.512 173.577 304.005Z"
			fill="#559BF0"
		/>
		<path
			d="M219.778 304.005C212.892 299.467 204.021 300.738 199.952 306.884C195.859 312.999 198.171 321.631 205.052 326.168C211.938 330.706 220.809 329.435 224.877 323.289C228.915 317.169 226.638 308.512 219.778 304.005Z"
			fill="#559BF0"
		/>
	</svg>
);

export const StyleSVG = () => (
	<svg
		width="200"
		height="200"
		viewBox="0 0 480 480"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.5006 64.3244C19.4728 63.1639 20.391 62.2006 21.5514 62.1728L429.316 52.3983C430.476 52.3705 431.439 53.2887 431.467 54.4491L439.489 389.104C439.517 390.265 438.599 391.228 437.438 391.256L29.6742 401.03C28.5137 401.058 27.5504 400.14 27.5226 398.98L19.5006 64.3244Z"
			fill="#FEBBF7"
		/>
		<path
			d="M40.3382 86.9035C40.2978 85.7434 41.2055 84.7703 42.3656 84.7299L402.285 72.1971C403.445 72.1567 404.418 73.0644 404.459 74.2245L414.372 358.911C414.412 360.071 413.504 361.044 412.344 361.084L52.4249 373.617C51.2649 373.657 50.2917 372.75 50.2513 371.59L40.3382 86.9035Z"
			fill="#FFE4FB"
		/>
		<path
			d="M172.054 110.565C172.02 109.869 172.557 109.278 173.252 109.244L320.254 102.122C320.95 102.088 321.541 102.625 321.575 103.32L329.959 276.348C329.992 277.044 329.456 277.635 328.76 277.669L181.758 284.791C181.062 284.825 180.471 284.288 180.437 283.593L172.054 110.565Z"
			fill="#C4DFF9"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M217.527 184.674C203.205 178.974 195.335 165.043 198.257 151.846L259.584 167.058C259.266 168.108 258.878 169.15 258.417 170.181C252.872 182.525 238.615 189.066 224.542 186.654L216.29 221.681C215.171 226.193 217.232 230.506 221.612 232.064C226.938 233.959 230.335 235.828 230.062 236.93C229.642 238.623 220.715 237.866 210.124 235.239C199.533 232.612 191.288 229.11 191.708 227.416C191.998 226.245 196.356 226.246 202.518 227.226C207.199 227.971 210.731 225.134 211.794 220.515L218.443 185.025C218.137 184.913 217.832 184.796 217.527 184.674Z"
			fill="#E6F2FC"
		/>
		<path
			d="M254.923 168.456L203.198 163C203.198 163 202.507 172.667 218.82 180.781C235.132 188.894 250.419 176.02 254.923 168.456Z"
			fill="#FA592D"
		/>
		<path
			d="M260.377 179.405C252.463 175.179 246.937 167.816 245.734 159.172L308.517 152.048C308.585 153.143 308.585 154.255 308.512 155.382C308.057 162.257 304.96 168.51 300.178 173.341C301.93 183.211 301.573 193.875 288.667 197.33L293.316 232.4C293.873 237.015 297.332 240.315 301.98 240.215C307.631 240.094 311.471 240.634 311.607 241.762C311.816 243.494 303.203 245.957 292.369 247.264C281.536 248.571 272.584 248.226 272.375 246.494C272.23 245.296 276.304 243.749 282.413 242.476C287.053 241.509 289.347 237.603 288.7 232.907L282.481 198.335C281.247 198.43 279.937 198.479 278.545 198.479C268.007 198.479 262.473 189.331 260.377 179.405Z"
			fill="#E6F2FC"
		/>
		<path
			d="M301.134 164.269C305.152 158.097 304.973 150.321 300.422 145.861C295.321 140.844 286.52 141.937 280.808 148.3C280.4 148.755 280.019 149.225 279.665 149.706L301.134 164.269Z"
			fill="#FA592D"
		/>
		<path
			d="M260.862 160.592C269.954 166.342 289.72 168.002 298.466 168.113C298.466 168.113 296.962 192.247 280.917 193.182C264.873 194.118 260.862 171.846 260.862 160.592Z"
			fill="#FA38C4"
		/>
		<path
			d="M53.7197 212.418C53.5266 211.748 53.9125 211.049 54.5817 210.856L194.42 170.506C195.09 170.313 195.789 170.699 195.982 171.368L238.801 319.765C238.994 320.435 238.609 321.134 237.939 321.327L98.1007 361.677C97.4315 361.87 96.7325 361.484 96.5395 360.815L53.7197 212.418Z"
			fill="#FA38C4"
		/>
		<path
			d="M116.042 219.152C145.949 201.097 183.667 207.422 200.327 233.448C217.1 259.35 206.244 294.96 176.358 313.016C146.45 331.072 108.733 324.746 92.0727 298.72C75.5404 272.804 86.2469 237.084 116.042 219.152Z"
			fill="#C4DFF9"
		/>
		<path
			d="M178.961 251.371L173.641 237.723L183.993 237.048L190.495 251.754L178.961 251.371Z"
			fill="#559BF0"
		/>
		<path
			d="M167.271 224.183L161.424 215.302L168.901 215.125L175.195 223.315L167.271 224.183Z"
			fill="#559BF0"
		/>
		<path
			d="M171.362 307.997L172.117 291.809L182.182 289.645L180.443 306.044L171.362 307.997Z"
			fill="#559BF0"
		/>
		<path
			d="M155.868 226.633L160.332 237.96L172.459 236.664L166.187 225.25L155.868 226.633Z"
			fill="#A1CDF5"
		/>
		<path
			d="M153.2 254.165L164.366 252.838L168.215 270.738L156.976 271.723L153.2 254.165Z"
			fill="#A1CDF5"
		/>
		<path
			d="M160.664 238.901L172.153 237.784L176.906 251.498L165.325 252.183L160.664 238.901Z"
			fill="#A1CDF5"
		/>
		<path
			d="M91.9165 224.144C91.9165 224.144 98.7176 225.916 102.103 220.784C102.103 220.784 103.435 227.565 109.172 229.512C109.172 229.512 104.183 231.727 103.467 239.247C103.467 239.247 99.1687 233.838 91.9823 236.796C91.9879 236.822 94.8828 230.356 91.9165 224.144Z"
			fill="#FFE4FB"
		/>
		<path
			d="M194.317 290.552C194.317 290.552 198.646 296.089 204.451 294.066C204.451 294.066 201.394 300.263 204.77 305.293C204.77 305.293 199.461 304.024 194.327 309.565C194.327 309.565 194.195 302.658 186.688 300.646C186.677 300.67 192.905 297.29 194.319 290.553L194.317 290.552Z"
			fill="#FBBB03"
		/>
		<path
			d="M368.06 189.67L445.136 221.291L354.307 442.684L278.554 413.027L368.06 189.67Z"
			fill="#FBBB03"
		/>
		<path
			d="M392.242 187.21L467.29 223.381L360.137 445.705L285.088 409.534L392.242 187.21Z"
			fill="#FBBB03"
		/>
		<path
			d="M349.213 192.691L433.333 220.039L359.35 447.604L275.231 420.256L349.213 192.691Z"
			fill="#FFF7E1"
		/>
		<path
			d="M334.779 408.295C335.548 414.224 330.411 419.779 323.305 420.701C316.199 421.623 309.814 417.564 309.045 411.635C308.275 405.705 313.412 400.151 320.518 399.229C327.624 398.306 334.009 402.365 334.779 408.295Z"
			fill="#FBBB03"
		/>
		<path
			d="M352.574 201.457L420.163 222.694L403.717 275.036L336.127 253.799L352.574 201.457Z"
			fill="#FA592D"
		/>
		<path
			d="M333.778 261.554L401.367 282.792L384.92 335.134L317.331 313.897L333.778 261.554Z"
			fill="#FF6F00"
		/>
		<path
			d="M315.277 322.896L382.347 343.919L365.865 396.247L298.795 375.224L315.277 322.896Z"
			fill="#FBBB03"
		/>
	</svg>
);

export const OptionSVG = () => (
	<svg
		width="200"
		height="200"
		viewBox="0 0 481 481"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M183.715 29.4138C183.715 24.4908 187.66 20.4999 192.527 20.4999H451.69C456.557 20.4999 460.502 24.4908 460.502 29.4138V291.586C460.502 296.509 456.557 300.5 451.69 300.5H192.527C187.66 300.5 183.715 296.509 183.715 291.586V29.4138Z"
			fill="#C4DFF9"
		/>
		<path
			d="M204.988 55.4852C200.126 54.3883 197.375 49.217 198.797 43.9524C200.204 38.7114 205.285 35.325 210.121 36.4079C214.984 37.5047 217.735 42.6761 216.313 47.9408C214.891 53.2005 209.834 56.6041 204.988 55.4852Z"
			fill="#A1CDF5"
		/>
		<path
			d="M224.943 43.9524C223.521 49.217 226.272 54.3883 231.134 55.4852C235.98 56.6041 241.037 53.2005 242.459 47.9408C243.88 42.6761 241.13 37.5047 236.267 36.4079C231.431 35.325 226.35 38.7114 224.943 43.9524Z"
			fill="#A1CDF5"
		/>
		<path
			d="M251.089 43.9524C249.667 49.217 252.418 54.3883 257.28 55.4852C262.126 56.6041 267.183 53.2005 268.605 47.9408C270.027 42.6761 267.276 37.5047 262.413 36.4079C257.577 35.325 252.496 38.7114 251.089 43.9524Z"
			fill="#A1CDF5"
		/>
		<path
			d="M401.675 61.5374C412.588 51.2822 411.562 43.8522 406.484 38.7897L406.482 38.784C403.199 35.5128 392.598 44.1878 392.598 44.1878C392.221 44.3227 372.672 60.2019 372.173 60.7881L371.015 62.1466C370.646 62.576 367.416 66.4484 367.653 71.0224C367.833 74.4976 370.056 76.9136 371.224 78.1833C371.594 78.5847 371.858 78.8715 371.918 79.041C372.088 79.516 352.141 119.744 337.385 149.39C329.711 145.62 324.978 140.614 325.506 134.241C325.731 131.531 326.493 128.437 327.28 125.244C329.883 114.681 332.752 103.036 317.299 100.651C307.012 99.0617 284.259 111.189 283.471 137.377C283.317 142.464 283.452 147.016 283.574 151.177C284.083 168.435 284.393 178.963 263.182 193.048C236.858 210.527 240.835 257.723 271.158 277.461C301.481 297.198 325.486 293.223 342.833 280.686C366.238 263.768 367.986 241.643 369.443 223.201C370.677 207.578 371.702 194.598 385.505 189.663C402.423 181.763 405.662 158.808 387.064 158.528C376.935 158.377 366.185 157.38 356.549 155.439L386.788 86.9567C387.082 86.3015 387.818 85.9802 388.499 86.209C409.253 93.1529 402.743 67.6778 401.352 62.8692C401.217 62.4001 401.318 61.8721 401.675 61.5374Z"
			fill="#FBAF00"
		/>
		<path
			d="M316.882 149.823C316.065 148.611 315.378 147.338 314.795 146.006C313.444 142.923 312.458 139.66 310.978 136.639C309.801 134.269 307.881 132.476 305.072 132.5C294.911 132.668 291.026 143.564 294.929 154.479C298.231 163.715 302.51 177.044 295.689 185.696C286.318 197.569 265.731 207.474 272.344 225.677C273.989 230.189 277.367 233.639 281.588 235.891C287.99 239.333 295.827 240.205 302.783 242.063C311.94 244.521 321.759 248.761 326.091 257.778C328.062 261.896 328.672 270.4 334.531 270.847C342.97 271.472 347.986 263.081 350.437 256.199C352.4 250.63 353.353 244.715 353.211 238.835C353.069 232.955 351.35 227.592 350.548 221.883C349.172 212.138 350.373 202.998 357.54 195.745C369.95 183.193 349.416 169.223 339.62 163.964C334.295 161.105 328.247 159.677 323.237 156.238C320.731 154.505 318.576 152.351 316.882 149.823Z"
			fill="#FFF7E1"
		/>
		<path
			d="M334.63 213.974L304.174 202.885L299.364 215.951L327.465 226.732L334.63 213.974Z"
			fill="#FF6F00"
		/>
		<path
			d="M316.69 168.051L313.877 176.178L346.097 190.156L350.658 181.021L316.69 168.051Z"
			fill="#FF6F00"
		/>
		<path
			d="M309.143 184.326L306.333 191.73L338.553 205.708L343.111 197.295L309.143 184.326Z"
			fill="#FF6F00"
		/>
		<path
			d="M402.454 95.4836C397.584 102.521 395.45 111.145 396.445 119.656L396.646 121.372L395.964 120.809C388.784 115.214 379.712 112.643 370.682 113.614L370.243 113.656L371.196 112.42C376.28 105.694 378.775 97.3687 378.233 88.9627L378.245 88.703L379.153 89.3183C385.677 93.8308 393.528 96.0009 401.382 95.4748L402.454 95.4836Z"
			fill="#E6F2FC"
		/>
		<path
			d="M20.498 224.845C20.498 219.75 24.4432 215.62 29.3097 215.62H277.132C281.998 215.62 285.943 219.75 285.943 224.845V451.275C285.943 456.37 281.998 460.5 277.132 460.5H29.3097C24.4432 460.5 20.498 456.37 20.498 451.275V224.845Z"
			fill="#FDDE81"
		/>
		<path
			d="M41.7715 250.608C36.9088 249.511 34.1584 244.34 35.5798 239.075C36.9869 233.834 42.0681 230.448 46.9041 231.53C51.767 232.627 54.5175 237.799 53.0961 243.063C51.674 248.323 46.6172 251.727 41.7715 250.608Z"
			fill="#FBBB03"
		/>
		<path
			d="M61.7257 239.075C60.3043 244.34 63.0547 249.511 67.9174 250.608C72.7631 251.727 77.8199 248.323 79.242 243.063C80.6635 237.799 77.9129 232.627 73.05 231.53C68.214 230.448 63.1328 233.834 61.7257 239.075Z"
			fill="#FBBB03"
		/>
		<path
			d="M87.8718 239.075C86.4503 244.34 89.2007 249.511 94.0634 250.608C98.9092 251.727 103.966 248.323 105.388 243.063C106.81 237.799 104.059 232.627 99.1961 231.53C94.3601 230.448 89.2789 233.834 87.8718 239.075Z"
			fill="#FBBB03"
		/>
		<path
			d="M238.031 299.9L71.7967 312.144C70.0585 312.272 68.6833 313.667 68.5792 315.407L64.4081 385.135C64.2933 387.053 65.7551 388.701 67.6732 388.816L232.117 398.664L238.031 299.9Z"
			fill="#FEBBF7"
		/>
		<path
			d="M67.5827 332.017L213.187 335.963C217.118 336.07 220.179 339.41 219.944 343.336L219.35 353.262C219.112 357.237 215.593 360.201 211.635 359.762L66.8844 343.677L67.5827 332.017Z"
			fill="#FA38C4"
		/>
		<path
			d="M39.8263 372.985C39.796 371.809 40.8884 370.966 42.0835 371.1L255.705 394.927C256.9 395.06 257.776 396.122 257.482 397.261C254.701 408.036 240.389 415.11 224.194 413.304L68.6692 395.957C52.4751 394.15 40.1128 384.101 39.8263 372.985Z"
			fill="#FF6F00"
		/>
		<path
			d="M153.858 281.757C165.093 275.282 178.897 278.11 184.705 288.139C190.556 298.122 186.115 311.452 174.889 317.928C163.654 324.403 149.85 321.574 144.042 311.546C138.28 301.56 142.667 288.186 153.858 281.757Z"
			fill="#FA38C4"
		/>
		<path
			d="M308.547 234.904V350.837C308.547 351.066 308.799 351.205 308.992 351.082L337.992 332.683C338.141 332.588 338.34 332.648 338.412 332.81L365.301 393.129L435.569 351.365L387.254 309.885C387.097 309.75 387.128 309.498 387.314 309.405L424.232 291.002C424.447 290.894 424.446 290.587 424.23 290.481L309.219 234.483C308.909 234.332 308.547 234.558 308.547 234.904Z"
			fill="#FA38C4"
		/>
	</svg>
);
